import { ShippingMethodsApiService } from '../../common/services/shipping-methods.api.service';
import { ShippingMethodModel } from '../../common/models/shipping-method.model';
import REQUEST_STATUS from '../../common/enums/requestStatus';

export default {
  namespaced: true,
  state: {
    status: REQUEST_STATUS.LOADING,
    items: [],
  },
  getters: {
    getAllShippingMethods: state => state.items,
    getStatus: state => state.status,
    getShippingMethod: state => id => state.items.find(item => item.id === id),
  },
  mutations: {
    SET_ITEMS(state, data) {
      state.items = data;
    },
    SET_ITEM(state, data) {
      const arrayIndex = state.items.findIndex(item => item.id === data.id);

      if (arrayIndex === -1) {
        state.items.push(data);
      } else {
        this.$app.$set(state.items, arrayIndex, data);
      }
    },
    FETCH_REQUEST(state) {
      state.status = REQUEST_STATUS.LOADING;
    },
    FETCH_SUCCESS(state) {
      state.status = REQUEST_STATUS.SUCCESS;
    },
    FETCH_FAIL(state) {
      state.status = REQUEST_STATUS.FAIL;
    },
  },
  actions: {
    fetchAllShippingMethods({ commit, dispatch }) {
      commit('FETCH_REQUEST');

      return ShippingMethodsApiService.getAll()
        .then(response => {
          commit('SET_ITEMS', response.getItems());
          commit('FETCH_SUCCESS');
        })
        .catch(response => {
          dispatch('handleError', response);
        });
    },

    fetchShippingMethod({ commit, dispatch }, id) {
      commit('FETCH_REQUEST');

      return ShippingMethodsApiService.get(id, builder => {
        builder.embed([ShippingMethodModel.EMBED_CUSTOMER_GROUP_IDS]);
      })
        .then(response => {
          commit('SET_ITEM', response.getItem());
          commit('FETCH_SUCCESS');
        })
        .catch(response => {
          dispatch('handleError', response);
        });
    },

    handleError({ commit }, response) {
      commit('FETCH_FAIL');
      const message = response.getFirstValidationErrorMessage() || response.getMessage();
      this.$app.$alertError(message);
    },
  },
};
